export const language: any ={
  LabelCarts:"Giỏ hàng",
  Material:"Nguyên liệu",
  nodata: "Giỏ hàng trống",
}

